import React from "react";
import { Header } from "./styles";
import { Grid, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AlertLineReportDTO } from "../../../models/alert-line-report/alert-line-report-dto";
import ExportAlertLineReport from "../../../containers/AlertLineReport/ExportAlertLineReport";
import AlertLineURLLogo from "../../../containers/AlertLineURLsTable/AlertLineURLLogo";

interface Props {
  alertLineURLId?: string;
  previousReport?: AlertLineReportDTO;
  setLoading?: (loading: boolean) => void;
}

const AlertLinePageHeader = ({ alertLineURLId, previousReport, setLoading }: Props) => {
  const tRP = "pages.alert_line_report";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <Header>
        <Grid style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <Typography variant="h3">
            {previousReport ? `${t(`${tRP}.report_title`)}` : `${t(`${tRP}.title`)}`}
          </Typography>
          {previousReport && setLoading && (
            <ExportAlertLineReport
              alertLineReport={previousReport}
              setExportLoading={setLoading}
              customButtonStyle={{ backgroundColor: theme.palette.primary.main }}
              asReviewer={false}
            />
          )}
        </Grid>

        <Grid style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {alertLineURLId && <AlertLineURLLogo alertLineURLId={alertLineURLId} />}
        </Grid>
      </Header>
    </>
  );
};
export default AlertLinePageHeader;
